export default "__VITE_ASSET__Btfhn8qQ__"